import { currency } from '../../utils/currency'
import cn from 'classnames'


export const Price = ({ price, p, promo, className }) => {
   if (promo) {
      return (
         <div className={cn('price', 'price_discount', className)}>
            <p>{currency(p)}</p>
            <span>-{(((price - p) * 100) / price).toFixed(1)} %</span>
            <del>&nbsp;{price}&nbsp;</del>
         </div>
      )
   }
   return <p className={cn('price', className)}>{currency(p)}</p>
}
